<script>
  import { toast } from "@zerodevx/svelte-toast";
  import store from "../etleneumAccountStore";
  import Button from "./Button.svelte";
  import Invoice from "./Invoice.svelte";
  import Ticket from "./Ticket.svelte";
  export let num;
  export let validate, prepareCall, stream, sats, canDraw;
  export let tickets;
  $: validNum = validate(num);
  let invoice;

  $: console.log(tickets);

  async function callDraw() {
    if (!canDraw) {
      toast.push("Apenas um sorteio a cada 144 blocos (1 dia)!");
      return;
    }
    let res = await prepareCall("draw", 0, {}, $store.session);
    console.log(res);
    invoice = res.invoice;
    streamListen(res.id, "draw");
  }

  async function callBuyTicket(number) {
    if (tickets[number].user) {
      return toast.push("Bilhete indisponível");
    }
    let res = await prepareCall(
      "buyticket",
      sats * 1000,
      { number },
      $store.session
    );

    invoice = res.invoice;
    streamListen(res.id);
  }

  function streamListen(id, method = "buyticket") {
    stream(
      (callId) => {
        if (callId === id) {
          console.log("our call was executed!", callId);
          method == "draw"
            ? toast.push("Sorteio iniciado!")
            : toast.push(`Comprado bilhete numero ${num}!`);
          invoice = null;
          num = null;
        } else {
          console.log("someone else's call was executed!");
        }
      },
      (callId, errMsg) => {
        console.log("a call resulted in an error", callId, errMsg);
      }
    );
  }
</script>

<section id="buySection">
  <header>
    <h2>Comprar Bilhete</h2>
  </header>
  <form action="">
    <fieldset>
      <input
        id="number"
        type="number"
        min="0"
        max="4096"
        on:change={validNum}
        bind:value={num}
        required
      />
      <label for="number"><span>Num. 0-4096</span></label>
    </fieldset>
    <div class="action">
      <Button
        disabled={!validNum}
        style="--color: var(--pinker)"
        clickAction={() => callBuyTicket(num)}>Comprar</Button
      >
      <Button title="Sortear" disabled={!canDraw} clickAction={callDraw} />
    </div>
  </form>
</section>
{#if invoice}
  <svelte:component this={Invoice} {invoice} />
  <Button
    title="Cancelar"
    style="--color: var(--pinker)"
    clickAction={() => (invoice = null)}
  />
{/if}

<style>
  section {
    position: relative;
    margin: 0 auto;
    width: 90%;
    max-width: 960px;
  }
  form {
    display: grid;
    grid-template-columns: 0.75fr 1fr;
    align-items: end;
    justify-content: center;
  }
  fieldset {
    padding: 0;
    border: 0;
  }
  input:focus {
    outline: 0;
  }
  input,
  span,
  label {
    display: block;
    margin: 10px;
    padding: 5px;
    border: none;
    font-size: 1rem;
  }
  input {
    margin: 0;
    border: none;
    width: 80%;
    transition: padding-top 0.2s ease, margin-top 0.2s ease;
    overflow-x: hidden;
    background: rgba(0, 0, 0, 0);
    padding-top: 1rem;
  }

  input + label {
    display: block;
    position: relative;
    white-space: nowrap;
    padding: 0;
    margin: 0;
    width: 10%;
    height: 0;
    border-top: 1px solid var(--pinker);
    transition: width 0.4s ease;
  }
  input:focus + label {
    width: 80%;
  }
  input:valid + label {
    border-color: var(--green);
  }
  input + label > span {
    margin: 0;
    position: absolute;
    color: #8f8f8f;
    top: -44px;
    left: 0px;
    z-index: -1;
    transition: top 0.2s ease, font-size 0.2s ease, color 0.2s ease;
  }
  input:focus + label > span,
  input:valid + label > span {
    top: -66px;
    color: #333;
    font-size: 0.75rem;
  }

  .action {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    height: 100%;
  }

  @media (min-width: 600px) {
    form {
      grid-template-columns: 1fr 1fr;
    }
  }
</style>
